var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuestRoom = function SvgGuestRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 12v12h-2.77v-3.6H2.77V24H0V1.8c0-.236.035-.47.105-.69.07-.218.171-.416.3-.583Q.6.274.855.137c.168-.09.348-.137.53-.137.157-.001.314.035.461.108.27.123.503.352.669.655.165.303.254.665.254 1.037V12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.23 20.4H24V24h-2.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M2.77 12H24v4.8H2.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.77 16.8H24v3.6H2.77z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M7.846 8.4h-.923c-.765 0-1.385.806-1.385 1.8s.62 1.8 1.385 1.8h.923c.765 0 1.385-.806 1.385-1.8s-.62-1.8-1.385-1.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.538 10.2c0 .477.146.935.406 1.273s.612.527.98.527h.922c.367 0 .72-.19.98-.527.259-.338.405-.796.405-1.273z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M2.77 1.8V24h-.924V.108c.27.123.503.352.669.655.165.303.254.665.254 1.037"
  })));
};
export default SvgGuestRoom;